import { render, staticRenderFns } from "./TableBasicPatients.vue?vue&type=template&id=049e59b6&"
import script from "./TableBasicPatients.vue?vue&type=script&lang=js&"
export * from "./TableBasicPatients.vue?vue&type=script&lang=js&"
import style0 from "./TableBasicPatients.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports